import {Test, TestGroup} from "../CreateNewState";

export function getNextOrderNumberByTestGroup(testGroup: TestGroup) {
    if (!testGroup.tests || !testGroup.tests.length) return 1;

    let latestOrderNumber = 0;

    testGroup.tests.forEach((testGroup) => {
        if (latestOrderNumber < testGroup.order) {
            latestOrderNumber = testGroup.order;
        }
    })

    return ++latestOrderNumber;
}

export function getTestGroupOptions(testGroups: TestGroup[]) {
    return testGroups
        .map((testGroup) => {
            return {
                label: `${testGroup.groupType} - ${testGroup.title}`,
                value: testGroup.id,
            }
        })
        .sort((a, b) => a.label.localeCompare(b.label))
}

export function getTestRowIds(testGroups: TestGroup[]) {
    const testIds: string[] = [];

    testGroups
        .filter((testGroup) => testGroup.tests && testGroup.tests.length)
        .forEach((testGroup) => {
            testGroup.tests.forEach((test) => {
                testIds.push(test.id);
            })
        })

    return testIds
}

export function checkIfOrderExists(order: number, id: string, testGroupsIds: string[], testGroups: TestGroup[]) {
    const testGroupAndTest: string[] = [];

    if (!testGroupsIds || !testGroupsIds.length) return testGroupAndTest;

    testGroups.forEach((testGroup) => {
        if (testGroupsIds.includes(testGroup.id) && testGroup.tests) {
            testGroup.tests.forEach((test) => {
                if (test.order === order && id !== test.id) {
                    testGroupAndTest.push(`Order: ${order} is exists for Test - ${test.title} in Test Group - ${testGroup.title} \n`)
                }
            })
        }
    })

    return testGroupAndTest;
}

export function checkIfTestOrderExists(order: number, id: string, tests: Test[]) {
    const testAndOrderErrors: string[] = [];

    if (!id || !tests.length) return testAndOrderErrors;

    tests.forEach((test) => {
        if (test.order === order && id !== test.id) {
            testAndOrderErrors.push(`Order: ${order} is exists for Test - ${test.title}`)
        }
    })

    return testAndOrderErrors;
}

export function findParentGroupId(testId: string, testGroups: TestGroup[]) {
    for (let testGroup of testGroups) {
        if (testGroup.tests && testGroup.tests.length) {
            for (let test of testGroup.tests) {
                if (test.id === testId) {
                    return testGroup.id;
                }
            }
        }
    }
}

export function findParentGroupById(testGroupId: string, testGroups: TestGroup[]) {
    for (let testGroup of testGroups) {
        if (testGroup.id === testGroupId) {
            return testGroup
        }
    }

    return null;
}